export default "__VITE_ASSET__43644f78__"